import { darken } from 'polished';
import styled, { keyframes } from 'styled-components';

import { ImageBackgroundLogoIbFullscreen } from '~/assets/images';

const appearOpacity = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

export const Container = styled.div`
  background: url(${ImageBackgroundLogoIbFullscreen}) 0% / cover fixed,
    ${(props) => props.theme.colors.background};

  flex: 1;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  position: relative;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  width: 100%;
  max-width: 38.7rem;

  padding: 2rem;

  animation: ${appearOpacity} 0.5s ease-in;

  @media (min-width: 768px) {
    padding: 0;
  }

  > svg {
  }
`;

export const ButtonSignUp = styled.button`
  width: 100%;
  height: 5.8rem;

  background: #ffffff;
  border-radius: 5rem;
  margin-top: 2.7rem;

  font-weight: ${({ theme }) => theme.fontWeight.LatoBold};
  font-size: 2.5rem;
  letter-spacing: 0.5rem;
  color: #000000;
  text-transform: uppercase;

  transition: 180ms ease-in;

  &:hover {
    background: ${darken(0.2, '#ffffff')};
  }
`;

export const SloganText = styled.p`
  font-weight: ${({ theme }) => theme.fontWeight.LatoBold};
  font-size: 3rem;
  letter-spacing: 0.9px;
  color: #ffffff;

  text-align: center;

  max-width: 30rem;
  width: 100%;

  margin-top: 1.6rem;
  @media (min-width: 768px) {
    margin-top: 6.4rem;
  }
`;

export const ModalContent = styled.div`
  display: grid;
  grid-row-gap: 2.4rem;
  grid-column-gap: 1rem;
  grid-template-columns: auto 2.6rem;

  width: 100%;
  max-width: 43.6rem;

  padding: 0 2rem;

  @media (min-width: 768px) {
    padding: 0;
  }
`;

export const ModalTitle = styled.h1`
  text-align: center;
  margin-bottom: 0.6rem;
  text-transform: uppercase;
  letter-spacing: 0.14rem;
  font-size: 2.8rem;
`;

export const Popup = styled.div`
  cursor: pointer;

  display: flex;
  align-items: center;
  position: relative;

  > svg {
    position: absolute;
  }

  > div {
    position: absolute;

    pointer-events: none;

    display: flex;
    align-items: center;
    justify-content: center;
    top: 80%;
    right: -20%;

    z-index: 99;

    width: 20rem;
    padding: 2rem;

    background: #ffffff;
    box-shadow: 0px 1px 5px #0000001a;
    border-radius: 5px;

    opacity: 0;
    transition: all 300ms ease-in-out;

    cursor: text;

    @media (min-width: 400px) {
      width: 35.4rem;
      height: 51px;
      padding: 0;
    }
  }

  &:hover {
    > div {
      pointer-events: visible;
      opacity: 1;
    }
  }
`;

export const ButtonBlack = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;

  text-align: center;

  font-size: 2.2rem;

  width: 100%;
  height: 5.8rem;

  background: transparent linear-gradient(98deg, #000000 0%, #232323 100%);
  border-radius: 5rem;

  transition: 180ms ease-in;

  color: #ffffff;
`;
